// extracted by css-extract-rspack-plugin
export default {"textarea":"textarea-BBtGNx text-body-base"};